/* eslint-disable react/prop-types */
import { RouteComponentProps } from "@reach/router"
import { DocumentTitleOverride, Text, Flex, SubTitle, Separator, Box, Card } from "@shared/primitive-components"
import * as styles from "./styles"
import { SettingsPortalTestIds } from "./types"
import { usePolicyAndFleet } from "../contexts"
import { TspsSection } from "./tsps/components/TspsSection"
import { ScreenContentWithContext } from "../components/ScreenContentWithContext"
import { LowConnectivityBanner, PrevPolicyDropdown } from "../ui/components"

const Container: React.FC = (props) => <Flex css={styles.Container} {...props} />

export const Settings: React.FC<RouteComponentProps> = () => {
  const { policy, connectivity } = usePolicyAndFleet()

  return (
    <>
      {!!(connectivity.data || policy.connectivityRatio) && <LowConnectivityBanner policy={policy} />}
      <DocumentTitleOverride>Flock Motor | Settings</DocumentTitleOverride>
      <ScreenContentWithContext
        title="Settings"
        dataTestIds={{ root: SettingsPortalTestIds.Portal }}
        PreviousPolicyDropdown={<PrevPolicyDropdown />}
      >
        <Card>
          <Container>
            <SubTitle>
              TELEMATICS SERVICE PROVIDER
              <Separator size="block" color="yellow" />
            </SubTitle>
            <Box>
              <Text css={styles.TSPInfoText}>
                If your Telematics Service Provider is not right in the navigation bar, please adjust this in the
                dropdown below.
              </Text>

              <Text>If you have more than one telematics solution, please add an additional dropdown.</Text>
            </Box>
            <Flex flexDirection="column" justifyContent="space-between" alignItems="center" height="60vh">
              <Flex flexDirection="column" alignItems="center" width="100%">
                <TspsSection policyId={policy.id} />
              </Flex>
              <Box>
                If your are having issues with the connectivity from your TSP please follow{` `}
                <Text
                  onClick={() =>
                    window.open(
                      `https://help.flockcover.com/how-do-i-fix-issues-connecting-my-telematics-data-to-flock`
                    )
                  }
                  css={styles.NavigateToKnowledgePage}
                >
                  this page
                </Text>
                {` `}
                for further guidance
              </Box>
            </Flex>
          </Container>
        </Card>
      </ScreenContentWithContext>
    </>
  )
}
